// Jewish-calendar util (Phase 8). Resolves which parasha is current ONLINE-FIRST
// each open (never trust cache for "which parasha"), Diaspora default, and handles
// the Motzei-Shabbos rollover (review fix RISK-3).

import { getThisWeekParasha, type ParashaWeek } from "./sefaria.ts";

// Whole days from `now` until the upcoming Shabbos (Saturday). 0 if today is
// Saturday. Pure day-math, no I/O. App code may pass new Date() freely.
export function daysUntilShabbos(now: Date): number {
  return (6 - now.getDay() + 7) % 7;
}

export interface WeekClock {
  week: ParashaWeek;
  untilShabbosDays: number;
}

// Resolve the current parasha online-first (rolls over Motzei Shabbos) and the
// honest count of days left until Shabbos.
export async function currentWeekClock(diaspora = true): Promise<WeekClock> {
  const week = await getThisWeekParasha(diaspora);
  return { week, untilShabbosDays: daysUntilShabbos(new Date()) };
}
